var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",attrs:{"height":_vm.bannerHeight + 'px'}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.bannerImg),expression:"bannerImg"}],ref:"bannerHeight",attrs:{"src":_vm.bannerImg},on:{"load":_vm.imgLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }